import { FETCH_CONTENT_SCHEMA_SUCCEEDED } from 'ContentEditorUI/redux/actions/actionTypes';
const initialState = {};
export const extraInitialStateReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CONTENT_SCHEMA_SUCCEEDED:
      return {
        baseApiUrl: state.baseApiUrl
      };
    default:
      return state;
  }
};